/*jshint esversion: 11 */

import PreparePayload from "./PreparePayload";
import { localforage, credKey, taskId, TOKEN_UUID } from "../config";


export default async function submitDataToParent ( data ) {
    const payload = PreparePayload( data );
    const credentials = await localforage.getItem( taskId + TOKEN_UUID );
    payload.sys = { ...credentials };

    payload.credKey  = credKey;

    const message = {
        type: 'fma-payload',
        payload: payload,
        taskId: taskId
    };

    window.parent.postMessage( message, '*' );

    return { status: 200 };
}
